export default function convertToEmbeddedGoogleDriveLink(url) {
  if (url.includes("drive.google.com")) {
    const id = url.split("/")[5];
    if (id) return `https://drive.google.com/file/d/${id}/preview`;
  }
  return url;
}
